import {
  all,
  chain,
  complement,
  compose,
  either,
  isEmpty,
  isNil,
  pick,
  values
} from 'ramda'

const isPresent = complement(either(isNil, isEmpty))
const elements = pick(['evidence', 'reasoning', 'counterargument'])
const elementValues = chain(compose(values, elements))

export const isClaimComplete = compose(all(isPresent), elementValues)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Builder/util.js